import { SignUp } from '@clerk/clerk-react';

export default function AcceptInvitationPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-white px-4">
      <div className="w-full max-w-md">
        <SignUp routing="path" path="/accept-invitation" />
      </div>
    </div>
  );
}

